/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 */

let cartDrawer = null;

/**
 * @returns {(HTMLElement & { open?: () => void }) | null}
 */
function getCartDrawer() {
  if (cartDrawer?.isConnected) {
    return cartDrawer;
  }

  cartDrawer =
    /** @type {(HTMLElement & { open?: () => void }) | null} */ (
      document.querySelector('theme-drawer#cart-drawer')
    );

  return cartDrawer;
}

function init() {
  const actions = window.Shopify?.actions;

  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => getCartDrawer() ?? document,
  });

  actions.openCart.configure({
    handler() {
      const drawer = getCartDrawer();

      if (typeof drawer?.open === 'function') {
        drawer.open();
        return;
      }

      window.location.href =
        Theme.routes.cart_url || '/cart';
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    init,
    { once: true }
  );
}